import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { SpinnerEvent } from './spinner.event';
import { AgilityRiskSpinnerService } from '../../../providers/agility-risk-spinner.service';

@Component({
  selector: 'lib-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnInit, OnDestroy {
  message = '';
  show = false;
  private subscription: Subscription;

  constructor(private spinnerService: AgilityRiskSpinnerService) {
  }

  ngOnInit(): void {
    this.subscription = this.spinnerService.status.subscribe((evt: SpinnerEvent) => {
      this.show = evt.spin;
      this.message = evt.message;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
